import React, { useState, useEffect } from 'react'
import DropdownCategory from './DropdownCategory';
import FormNavbar from './FormNavbar';
import Cart from './Cart';
import Like from './Like';

const Navbar = () => {
  const [top, setTop] = useState(true)
  useEffect(() => {
    document.addEventListener("scroll", e => {
      let scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 5) {
        setTop(false)
      } else {
        setTop(true)
      }      
    })
  }, [top])
  
  return (
    <>
      <div className={"navbar-wrapper navbar-sticky "+ (!top ? "navbar-shadow" : "")}>
        <div className="container">
          <nav className="navbar">
            <div className="navbar-left">
              <h1 className="logo">MoshiMoshiMall</h1>
            </div>
            <div className="navbar-center">
              <DropdownCategory />
              <FormNavbar />
            </div>
            <div className="navbar-right">
              <Cart />
              <Like />
              <a href="/login" className='login'>Masuk</a>
              <a href="/signup" className='signup'>Daftar</a>
            </div>
          </nav>
        </div>
      </div>
      <div style={{ marginTop: "110px" }}></div>
    </>
  )
}

export default Navbar
